<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-align: center;">I would like to dedicate this book to all of my friends, to those who I have adventured and run with. This story would never have been written without you.</p><br/>
<p style="text-align: center;">Thanks to you all</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?1bd5d7a6